import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { ImageSource } from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/AutomatedCatalogCarouselCard.types';
import AutomatedCatalogCarouselCardItemImage from '@/components/FeaturedCatalogCarousel/components/AutomatedCatalogCarouselCard/components/ItemImages/components/AutomatedCatalogCarouselCardItemImage';
import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { useAppSelector } from '@/redux/hooks';
import { getCatalogCoverLotsTransformed } from '@/redux/modules/catalog/catalogs/catalog.selectors';

type Props = {
    catalogId: number;
    shouldFillCardWidth?: boolean;
};

const AutomatedCatalogCarouselCardItemImages = ({ catalogId, shouldFillCardWidth = false }: Props) => {
    const isMobile = useIsMobileLayout();
    const {
        primaryImage,
        primaryImageHighDpi,
        primaryItemId,
        primaryItemTitle,
        secondaryImage,
        secondaryImageHighDpi,
        secondaryItemId,
        secondaryItemTitle,
        tertiaryImage,
        tertiaryImageHighDpi,
        tertiaryItemId,
        tertiaryItemTitle,
    } = useAppSelector((state) => getCatalogCoverLotsTransformed(state, catalogId));

    return (
        <div
            className={cn('relative flex', {
                'gap-sm': !isMobile,
                'gap-xs': isMobile,
                'w-full': shouldFillCardWidth,
            })}
        >
            <AutomatedCatalogCarouselCardItemImage
                alt={primaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Primary}
                itemId={primaryItemId}
                shouldFillCardWidth={shouldFillCardWidth}
                src={isMobile ? primaryImage : primaryImageHighDpi}
            />
            <AutomatedCatalogCarouselCardItemImage
                alt={secondaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Secondary}
                itemId={secondaryItemId}
                shouldFillCardWidth={shouldFillCardWidth}
                src={isMobile ? secondaryImage : secondaryImageHighDpi}
            />
            <AutomatedCatalogCarouselCardItemImage
                alt={tertiaryItemTitle}
                catalogId={catalogId}
                imageSource={ImageSource.Tertiary}
                itemId={tertiaryItemId}
                shouldFillCardWidth={shouldFillCardWidth}
                src={isMobile ? tertiaryImage : tertiaryImageHighDpi}
            />
        </div>
    );
};

export default AutomatedCatalogCarouselCardItemImages;
